export default function CompanyNews(){
	return (
		<div className="dark:text-white">
			<h1>News</h1>
			<p>Not implemented in demo.</p>
		</div>
	);
}